import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { getCameraActions, PageLayout } from 'components/PageLayout';
import { SimplePageLayout } from 'components/layouts/SimplePageLayout';
import { DonateContent } from './DonateContent';

const Content = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('donate.title')}</title>
      </Helmet>
      <SimplePageLayout>
        <DonateContent />
      </SimplePageLayout>
    </>
  );
};

export const Donate = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      data-cname="DonatePage"
      allowAppBanner={false}
      headerBarProps={{
        title: t('donate.title'),
        action: 'back',
        iconActions: getCameraActions(t),
      }}
    >
      <Content />
    </PageLayout>
  );
};
